import { Component, ViewEncapsulation } from '@angular/core';
import { EmailEnum } from '../../enums/email.enum';
import { FeedbackSubjectEnum } from '../../enums/feedback.enum';
import { ClientEmailService } from '../../services/client-email/client-email.service';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppFooterComponent {
  constructor(private clientEmailService: ClientEmailService) {}

  getFeedbackMailLink(): string {
    const to = EmailEnum.customerRulesSupport;
    const subject = FeedbackSubjectEnum.subject;
    return this.clientEmailService.getSimpleEmailLink(to, subject);
  }
}
